/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Cunoști persoane noi, conversezi, socializezi",
      "Număr de telefon incorect",
      "Get the app",
      "Continuă cu Apple",
      "Continuă cu Facebook",
      "Continuă cu Google",
      "Autentificare",
      "Înregistrare",
      "Pentru a continua, introdu caracterele pe care le vezi în câmpul de introducere.",
      "Continuă",
      "Introdu caracterele",
      "Verificare de securitate",
      "Reîncărcare",
      "Creează o parolă nouă, ușor de reținut:",
      "Actualizează",
      "Confirmare parolă",
      "Parola trebuie să aibă cel puțin {{num}} [[characters:num]]",
      "Parolă",
      "Creează o parolă nouă",
      "Badoo - The Blog",
      "Carieră",
      "Conversații",
      "Orașe",
      "Gestionare cookie",
      "Drepturi de autor © 2006 – prezent. Bumble. Toate drepturile rezervate.",
      "Apple și sigla Apple sunt mărci comerciale ale Apple Inc.{{__EOL__}}Google Play este o marcă comercială deținută de Google LLC.",
      "Descarcă",
      "Facebook",
      "Urmărește-ne",
      "Asistență",
      "Instagram",
      "Limbă",
      "LinkedIn",
      "Prezentare",
      "Badoo face parte din Bumble Inc.",
      "Politica de confidențialitate",
      "Safety Centre",
      "Hartă site",
      "Legea privind sclavia modernă",
      "Condiții de utilizare",
      "Twitter",
      "Introdu adresa de e-mail sau un număr de mobil și îți vom trimite instrucțiuni pentru crearea unei parole.",
      "Obține parolă nouă",
      "Introdu adresa de e-mail sau numărul de telefon",
      "Parolă uitată",
      "Modele prezentate doar în scop ilustrativ",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Nu e nevoie să formezi o conexiune cu cineva.{{__EOL__}}{{__EOL__}}Explorează conversații mai profunde și treci direct la partea valoroasă. Știi tu, partea în care ajungeți să vă cunoașteți cu adevărat.",
      "Ai chef de discutat?",
      "Prin înscriere, îți exprimi acordul privind <a class=\"link\" href=\"{{terms_url}}\">condițiile de utilizare</a>. Pentru a afla cum folosim datele tale, citește <a class=\"link\" href=\"{{privacy_url}}\">Politica de confidențialitate</a>",
      "Încurajăm mereu cât mai multă autenticitate, <br />pentru întâlniri reușite",
      "Bucură-te de întâlniri cu încredere.",
      "Sau",
      "Ai deja cont?",
      "Înregistrează-te cu e-mail sau număr de telefon",
      "Obține exact ce vrei din întâlniri.{{__EOL__}}Fără scuze.",
      "Vrei doar să conversezi? E perfect în regulă.{{__EOL__}}Cauți ceva serios? Absolut minunat.{{__EOL__}}{{__EOL__}}Iar dacă vreodată te răzgândești, poți face asta oricând.",
      "Vreau să cunosc lume",
      "Vreau să încep o relație",
      "Discuții pe chat",
      "Aici poți cunoaște oameni cu care rezonezi.",
      "{{name}}, {{age}}",
      "Siguranța ta este prioritatea noastră absolută.",
      "Centrul de siguranță este hub-ul nostru de cunoștințe, unde găsești sprijinul necesar pentru a te bucura de întâlniri cu toată încrederea.",
      "Vizitează Centrul de siguranță",
      "Siguranța<br/>înainte de orice!",
      "Din prima clipă, am simțit că va ieși bine…",
      "La început nu mă interesa o relație serioasă...",
      "Un mic sfat pentru oricine care folosește aplicația Badoo ar fi să fie ei înșiși...",
      "Badoo Povești reușite",
      "Află mai multe povești reușite",
      "{{num}}__CUT__Rating",
      "App Store de la Apple",
      "Ai încredere în noi! Am adus milioane peste milioane de oameni împreună începând din 2006.",
      "Peste {{num}} mil__CUT__de descărcări",
      {
            "__cfg": {
                  "lexem_id": 30716808,
                  "flex_vars_types": {
                        "num": "Num"
                  },
                  "values": {
                        "Default": "Peste {{num}} de milioane",
                        "num=singular": "Peste {{num}} milion",
                        "num=few": "Peste {{num}} milioane"
                  }
            }
      },
      "Google Play Store",
      "Suntem buni la ceea ce facem.",
      "Autentifică-te cu adresa de e-mail sau numărul de telefon",
      "Introdu parola",
      "Ai uitat parola?",
      "Înregistrează-te",
      "Nu ai un cont?",
      "Autentificare",
      "Înregistrare"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "caractere",
                  "caractere",
                  "caractere",
                  "caractere",
                  "caractere"
            ],
            "plural": [
                  "de caractere",
                  "de caractere",
                  "de caractere",
                  "de caractere",
                  "de caractere"
            ],
            "singular": [
                  "caracter",
                  "caracter",
                  "caracter",
                  "caracter",
                  "caracter"
            ]
      },
      "day": {
            "few": [
                  "zile",
                  "zile",
                  "zile",
                  "zile",
                  "zile"
            ],
            "plural": [
                  "de zile",
                  "de zile",
                  "de zile",
                  "de zile",
                  "de zile"
            ],
            "singular": [
                  "zi",
                  "zi",
                  "zi",
                  "zi",
                  "zi"
            ]
      },
      "hour": {
            "few": [
                  "ore",
                  "ore",
                  "ore",
                  "ore",
                  "ore"
            ],
            "plural": [
                  "de ore",
                  "de ore",
                  "de ore",
                  "de ore",
                  "de ore"
            ],
            "singular": [
                  "oră",
                  "oră",
                  "oră",
                  "oră",
                  "oră"
            ]
      },
      "minute": {
            "few": [
                  "minute",
                  "minute",
                  "minute",
                  "minute",
                  "minute"
            ],
            "plural": [
                  "de minute",
                  "de minute",
                  "de minute",
                  "de minute",
                  "de minute"
            ],
            "singular": [
                  "minut",
                  "minut",
                  "minut",
                  "minut",
                  "minut"
            ]
      },
      "month": {
            "few": [
                  "luni",
                  "luni",
                  "luni",
                  "luni",
                  "luni"
            ],
            "plural": [
                  "de luni",
                  "de luni",
                  "de luni",
                  "de luni",
                  "de luni"
            ],
            "singular": [
                  "lună",
                  "lună",
                  "lună",
                  "lună",
                  "lună"
            ]
      },
      "second": {
            "few": [
                  "secunde",
                  "secunde",
                  "secunde",
                  "secunde",
                  "secunde"
            ],
            "plural": [
                  "de secunde",
                  "de secunde",
                  "de secunde",
                  "de secunde",
                  "de secunde"
            ],
            "singular": [
                  "secundă",
                  "secundă",
                  "secundă",
                  "secundă",
                  "secundă"
            ]
      },
      "year": {
            "few": [
                  "ani",
                  "ani",
                  "ani",
                  "ani",
                  "ani"
            ],
            "plural": [
                  "de ani",
                  "de ani",
                  "de ani",
                  "de ani",
                  "de ani"
            ],
            "singular": [
                  "an",
                  "an",
                  "an",
                  "an",
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
